// extracted by mini-css-extract-plugin
export default {"modal-image-container":"styles_modal-image-container__056TP"};